/**
 * @file BackupDestinationErrors.tsx
 * @description Ошибки назначения копий от сервера (400
 * `backup_destination_invalid`, `details.errors`) — списком под карточкой
 * «Где хранить копии»: у каждой строки подпись поля по текущему типу.
 */

import { NoticeStrip } from "../../ui/NoticeStrip";
import type { BackupDestinationType, BackupFieldError } from "../../../lib/api-backups";
import { destinationFieldLabel } from "./backup-destination";

interface Props {
  errors: BackupFieldError[];
  type: BackupDestinationType;
}

export function BackupDestinationErrors({ errors, type }: Props) {
  if (errors.length === 0) return null;
  return (
    <NoticeStrip tone="error" title="Хранилище не сохранено">
      <ul className="mt-1 flex flex-col gap-0.5">
        {errors.map((e, i) => {
          const label = destinationFieldLabel(e.field, type);
          return (
            <li key={`${e.field}-${i}`}>
              {label ? <span className="font-medium">{label}: </span> : null}
              {e.message}
            </li>
          );
        })}
      </ul>
    </NoticeStrip>
  );
}
